/**
 * StickyCTA
 *
 * Also uses .js-call-me-popup-form in SendForm.js
 * to set a cookie and GTM event if form was sent
 *
 * @since 1.0.0
 */
import Cookies from 'js-cookie'

const CallMeBackPopup = () => {
  const prevOnload = window.onload;

  window.onload = () => {
    /**
     * Disable the call me back popup because of the meetwagen modal that now shows up. Delete this return statement if u want the popup to show again.
     */
    return;

    if (typeof prevOnload === 'function') {
      prevOnload()
    }

    const container = document.querySelector('.js-call-me-popup')
    const rentContainer = document.querySelector('.js-rent-popup')
    if (!container || (rentContainer && !Cookies.get('voltens_rent_popup'))) return
    const close = container.querySelector('.js-call-me-close')

    // Don't show popup if have cookie
    if (Cookies.get('bright_call_me_popup')) {
      return
    }

    // Save currentTime+30s in session
    if (!sessionStorage.getItem('popup')) {
      let now = new Date()
      const timeToTrigger = now.setSeconds(now.getSeconds() + 10)
      sessionStorage.setItem('popup', timeToTrigger)
    }
    // Show popup after 30s
    if (sessionStorage.getItem('popup')) {

      let timer = setInterval(() => {
        if (sessionStorage.getItem('popup') < new Date()) {
          container.classList.add('active')
          clearInterval(timer)
        }
      }, 1000)
    }

    // Remove popup after clicking away
    close.addEventListener('click', e => {
      e.preventDefault()
      container.classList.remove('active')

      // set cookie to show it was clicked_away
      Cookies.set('bright_call_me_popup', 'rejected', { expires: 1 })

      // gtm event
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'rejectedCallMePopup',
      })

      // remove session
      sessionStorage.removeItem('popup')
    })

  } // onLoad
}

export default CallMeBackPopup

// WEBPACK FOOTER //
// ./src/js/modules/CallMeBackPopup.js